import Global from '../Globals'

const url = Global.apiURL;

export default class Api {

    // Token
    token = "";
    userToken = "";
    headers = "";

    // Constructor
    constructor() {
        this.token = Global.institutionToken;
        this.userToken = Global.userToken;
        this.headers = { 'Content-Type': 'application/json', 'institutiontoken': this.token, 'usertoken': this.userToken, 'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c' };
    }

    // Method Get
    async get(resource) {
        const requestOptions = {
            method: 'GET',
            headers: this.headers
        };
        const response = await fetch(url + '/' + resource, requestOptions);
        const data = await response.json();
        return data;
    }

    // Method Post
    async post(resource, postData) {
        const requestOptions = {
            method: 'POST',
            headers: this.headers,
            body: JSON.stringify(postData)
        };
        const response = await fetch(url + '/' + resource, requestOptions);
        const data = await response.json();
        return data;
    }

    // Method PUT
    async put(resource, postData) {
        const requestOptions = {
            method: 'PUT',
            headers: this.headers,
            body: JSON.stringify(postData)
        };
        const response = await fetch(url + '/' + resource, requestOptions);
        const data = await response.json();
        return data;
    }
}